import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from './shared.service';
import { CmsMenu } from '../Components/dashboard/cms-menu/cms-menu.component';

@Injectable()

export class CmsMenuService {
    constructor(private _http: HttpClient, private _shared: SharedService) {}

    // Get CmsMenu items
    getCmsMenu(): Observable<CmsMenu[]> {
        return this._http.get<CmsMenu[]>(`${this._shared.apiPath}services`).pipe(catchError(this._shared.handleError));
    }

    // Edit CmsMenu item name
    updateCmsMenuItem(menuItem: CmsMenu): Observable<any> {
        return this._http.put<any>(`${this._shared.apiPath}services/${menuItem.cMSMenuID}`, menuItem).pipe(catchError(this._shared.handleError));
    }

    // Update CmsMenu item order
    updateCmsMenuOrder(order): Observable<any> {
        const payload = { result: order }
        return this._http.put<any>(`${this._shared.apiPath}services`, payload).pipe(catchError(this._shared.handleError));
    }
}